import { createContext, useContext, useEffect, useState } from "react";
import { gameApi } from "@/lib/api";

const GameAuthContext = createContext(null);
export const useGameAuth = () => useContext(GameAuthContext);

export function GameAuthProvider({ children }) {
  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("bmm_game_token");
    if (!t) { setLoading(false); return; }
    gameApi.get("/game/auth/me")
      .then((r) => setPlayer(r.data.player))
      .catch(() => localStorage.removeItem("bmm_game_token"))
      .finally(() => setLoading(false));
  }, []);

  const register = async (email, password, display_name) => {
    const { data } = await gameApi.post("/game/auth/register", { email, password, display_name });
    localStorage.setItem("bmm_game_token", data.token);
    setPlayer(data.player);
  };
  const login = async (email, password) => {
    const { data } = await gameApi.post("/game/auth/login", { email, password });
    localStorage.setItem("bmm_game_token", data.token);
    setPlayer(data.player);
  };
  const logout = () => { localStorage.removeItem("bmm_game_token"); setPlayer(null); };

  return (
    <GameAuthContext.Provider value={{ player, loading, register, login, logout, setPlayer }}>
      {children}
    </GameAuthContext.Provider>
  );
}
